export function IsCallback<T extends (...args: unknown[]) => void>(maybeFunc: unknown): maybeFunc is T {
    return typeof maybeFunc === 'function';
}

export type MaybeFunc<T> = T | (() => T);